// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1bVnI","validationTips":"StatementDescriptor_validationTips__3ndLk"};